"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _NavigationItems = _interopRequireDefault(require("../NavigationItems"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const IconList = [{
  name: "search",
  imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/search.png",
  href: 'search'
}, {
  name: "whatsapp",
  imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/whatsapp.png"
}, {
  name: "orders",
  imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/user.png",
  href: 'orders'
}, {
  name: "cart",
  imgSrc: "https://cdn.dotpe.in/kiranaStatic/icons/shoppingcart.png",
  href: 'cart'
}];

const Header = props => {
  var _props$storeData, _props$storeData$stor;

  const [iconListState] = (0, _react.useState)(IconList);

  const onHeaderLinkshandle = _ref => {
    let {
      type,
      href
    } = _ref;
    props.onHandleLink && props.onHandlePageClick(type, href);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "templateHeader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "templateHeader__inner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "templateHeader__inner--subsection"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "store-name",
    onClick: () => props.onHandlePageClick('')
  }, (_props$storeData = props.storeData) === null || _props$storeData === void 0 ? void 0 : (_props$storeData$stor = _props$storeData.store_info) === null || _props$storeData$stor === void 0 ? void 0 : _props$storeData$stor.name), /*#__PURE__*/_react.default.createElement(_NavigationItems.default, {
    categories: props === null || props === void 0 ? void 0 : props.categories,
    onHandlePageClick: props.onHandlePageClick,
    onCategoriesLinkHandle: props.onCategoriesLinkHandle,
    navItemList: props === null || props === void 0 ? void 0 : props.navItemList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "templateHeader__inner--subsection"
  }, iconListState.map(icon => /*#__PURE__*/_react.default.createElement("img", {
    key: icon.name,
    src: icon.imgSrc,
    width: "25",
    height: "25",
    onClick: () => onHandlePageClick(icon.href),
    style: icon.name === "search" ? {
      filter: "brightness(0)"
    } : {}
  })))));
};

var _default = Header;
exports.default = _default;